var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.764 4.98568C8.06315 4.98568 8.30566 5.22819 8.30566 5.52734L8.30566 13.1107C8.30566 13.4098 8.06315 13.6523 7.764 13.6523C7.46484 13.6523 7.22233 13.4098 7.22233 13.1107L7.22233 5.52734C7.22233 5.22819 7.46484 4.98568 7.764 4.98568ZM4.15289 0.652344C4.45204 0.652344 4.69455 0.894856 4.69455 1.19401L4.69455 13.1107C4.69455 13.4098 4.45204 13.6523 4.15289 13.6523C3.85373 13.6523 3.61122 13.4098 3.61122 13.1107L3.61122 1.19401C3.61122 0.894856 3.85373 0.652344 4.15289 0.652344ZM1.08344 5.52734C1.08344 5.22819 0.840929 4.98568 0.541775 4.98568C0.242621 4.98568 0.000108519 5.22819 0.000108506 5.52734L0.000108174 13.1107C0.000108161 13.4098 0.242621 13.6523 0.541775 13.6523C0.840929 13.6523 1.08344 13.4098 1.08344 13.1107L1.08344 5.52734Z",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.a4ed706e.svg";
export { ForwardRef as ReactComponent };